import React from 'react'
import { Box, Button, Link, Stack, Typography } from '@mui/material'
import { EmailShareButton, EmailIcon } from 'react-share'
import { TelegramShareButton, TelegramIcon } from 'react-share'
import { VKShareButton, VKIcon } from 'react-share'
import { pdf } from '@react-pdf/renderer'

import { useDialog } from '../hooks'
import { C2BQr } from '../types.ts'
import { MaxLogo } from '../assets/icons'

import { Dialog } from './dialog.tsx'
import { Icon } from './icon.tsx'
import { QrDownloadFile } from './qr-download-file.tsx'

interface ShareQrDialogProps extends Pick<C2BQr, 'image' | 'requestId' | 'type' | 'qrcType'> {
  url: string
}

export const ShareQrDialog = ({
  url,
  image,
  requestId,
  type,
  qrcType,
}: ShareQrDialogProps): React.ReactElement | null => {
  const { showDialog, handleShowDialog, handleHideDialog } = useDialog()
  const isC2B = type === 'C2B'
  const isStatic = qrcType === '01'

  const canShare = isC2B && isStatic

  const handlePDFDownload = async () => {
    const fileName = `C2B-qr-${requestId}.pdf`
    const blob = await pdf(<QrDownloadFile image={image} />).toBlob()

    // Create a new link
    const anchor = document.createElement('a')
    anchor.href = URL.createObjectURL(blob)
    anchor.download = fileName

    // Append to the DOM
    document.body.appendChild(anchor)

    // Trigger `click` event
    anchor.click()

    // Remove element from DOM
    document.body.removeChild(anchor)
  }

  const shareTitle = `Ссылка на оплату: ${url}`

  if (!isC2B) return null

  return (
    <>
      <Button onClick={handleShowDialog} sx={{ textWrap: 'nowrap' }} disabled={!canShare}>
        Показать QR-код
      </Button>
      <Dialog
        open={showDialog}
        maxWidth="sm"
        title="Поделиться ссылкой"
        onClose={handleHideDialog}
        content={
          <Stack gap={3}>
            <Stack gap={2} alignItems="center">
              <Box
                border={2}
                borderColor="background.paper"
                borderRadius={4}
                overflow="hidden"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <img src={`data:image/png;base64,${image}`} width="100%" />
              </Box>
              <Button onClick={handlePDFDownload} fullWidth>
                <Icon name="Bill" colorScheme="text.onControlsDark" />
                Скачать QR код
              </Button>
            </Stack>

            <Stack gap={2}>
              <Typography variant="h4">Поделиться</Typography>
              <Stack direction="row" gap={2}>
                <EmailShareButton
                  subject="Ссылка на оплату"
                  body={`Ссылка на оплату ${type} QR: `}
                  url={url}
                  aria-label="Share by email"
                >
                  <EmailIcon size={55} borderRadius={16} enableBackground />
                </EmailShareButton>
                <TelegramShareButton title="Ссылка на оплату" url={url} aria-label="Share on Telegram">
                  <TelegramIcon size={55} borderRadius={16} />
                </TelegramShareButton>
                <VKShareButton title="Ссылка на оплату" noParse noVkLinks url={url} aria-label="Share on VK">
                  <VKIcon size={55} borderRadius={16} />
                </VKShareButton>
                <Link href={`https://max.ru/:share?text=${shareTitle}`} target="_blank">
                  <Box width={55}>
                    <MaxLogo />
                  </Box>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        }
      />
    </>
  )
}
